



















































































import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { NoCache } from '@/decorators'

import PageTitle from '@/components/PageTitle.vue'
import EditRevenueModal from '@/components/EditRevenueModal.vue'
import EditExpenseModal from '@/components/EditExpenseModal.vue'

import { Revenue, Expense } from '@/services/models'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    EditRevenueModal,
    EditExpenseModal,
    PageTitle,
  },
})
export default class Ledger extends Vue {

  @Action('firestore/fetchLedgers')
  public fetchLedgers!: () => Promise<Ledger>

  @Getter('firestore/ledgers')
  public ledgers!: Ledger[]

  public formatters = formatters

  public get revenues(): Revenue[] {
    return this.ledgers
      .filter((o) => o instanceof Revenue)
      .map((o) => o as any)
  }

  public get expenses(): Expense[] {
    return this.ledgers
      .filter((o) => o instanceof Expense)
      .map((o) => o as any)
  }

  @NoCache
  public get editingRevenueModal(): EditRevenueModal {
    return this.$refs.editingRevenueModal as EditRevenueModal
  }

  @NoCache
  public get editingExpenseModal(): EditExpenseModal {
    return this.$refs.editingExpenseModal as EditExpenseModal
  }

  public mounted() {
    this.fetchLedgers()
  }

  private onRevenueComitted() {
    // pass
  }

  private onExpenseComitted() {
    // pass
  }

}
